import React from 'react';
import AuthCheck from '../components/auth-check.js';
import SettingsNotifications from '../components/employees/settings-employee-notifications.js';
import setTitle from '../decorators/set-title.js';
import NavBarAttendant from '../components/nav/navbar-attendant.js';

export class SettingsUserNotifications extends React.Component {
  render() {
    return (
      <div>
        <AuthCheck />
        <NavBarAttendant />
        <div className="variable-width-column">
          <div className="settings-panel">
            <SettingsNotifications />
          </div>
        </div>
      </div>
    );
  }
}

SettingsUserNotifications = setTitle((props) => {
  return 'User Settings';
})(SettingsUserNotifications);

export default SettingsUserNotifications;
